import {
  Card,
  CardContent,
  CircularProgress,
  Divider,
  IconButton,
  Typography,
  Backdrop,
  Grid,
  CardHeader,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Badge,
  TableContainer,
  Paper,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import { MdPhonelinkSetup } from 'react-icons/md';
import { VscFilePdf } from 'react-icons/vsc';
import { FaRegFileWord } from 'react-icons/fa';
import { RiFileExcel2Line } from 'react-icons/ri';
import { BiImage } from 'react-icons/bi';
import { GrDocumentZip } from 'react-icons/gr';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const useStyles = makeStyles((theme) => ({
  root: {},
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  }
}));


function BultenDetay({
  className, BultenDetay, Loading, setLoading
}) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [PdfUrl, setPdfUrl] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation('Work_Order');
  const [pdfPopUp, setPdfPopUp] = useState(false);


  const BultenDetayAc = (log) => {
    setLoading(true);
    const dataBultenDetay = {
      ServiceShopId: SessionUser.ServiceShopId,
      UserId: SessionUser.UserId,
      FilePtr: log.StreamId,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/SiriusBulletin', dataBultenDetay, config)
      .then((response) => {
      //  openBlob(response.data, log.BT + '_' + log.AY + '_' + log.BN);
        const fileURL = URL.createObjectURL(response.data);
        setPdfUrl(fileURL);
        window.open(fileURL);
        setLoading(false);
      }).catch((error) => {

        setLoading(false);
      });
  };
  const BultenVideoAc = (event, log) => {
    event.persist();
    window.open(log.Video);
    event.persist();
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const renderSwitch = (param) => {
    switch (param) {
      case 'image/bmp': return <BiImage />;
      case 'image/jpeg': return <BiImage />;
      case 'image/gif': return <BiImage />;
      case 'application/pdf': return <VscFilePdf />;
      case 'application/x-zip-compressed': return <GrDocumentZip />;
      case 'application/msword': return <FaRegFileWord />;
      case 'application/vnd.ms-excel': return <RiFileExcel2Line />;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return <RiFileExcel2Line />;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return <RiFileExcel2Line />;
      case 'application/x-msdownload': return <MdPhonelinkSetup />;
      case 'application/unknown': return <MdPhonelinkSetup />;
      case 'application/octet-stream': return <MdPhonelinkSetup />;
      default: return <MdPhonelinkSetup />;
    }
  };


  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title={t('Bulten')} />
        <Divider />
        <CardContent className={classes.content}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              {Loading
                ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                )
                : BultenDetay.length > 0 && BultenDetay.map((log) => (
                  <ExpansionPanel
                    key={log.DocumentType}
                    expanded={expanded === log.DocumentTypeId}
                    onChange={handleChange(log.DocumentTypeId)}
                  >
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography className={classes.secondaryHeading}>
                        {log.DocumentType}
                        <IconButton aria-label="cart">
                          <Badge badgeContent={log.Documents.length} color="secondary" />
                        </IconButton>
                      </Typography>
                    </ExpansionPanelSummary>

                    <ExpansionPanelDetails>
                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableBody>

                            {log.Documents.map((row) => (
                              <TableRow key={row.DocumentId}>
                                <TableCell
                                  component="th"
                                  onClick={(e) => BultenDetayAc(row)}
                                  scope="row"
                                >
                                  <IconButton aria-label="cart">
                                    {renderSwitch(row.StreamMimeType)}
                                  </IconButton>
                                  {row.StreamName}
                                </TableCell>
                              </TableRow>
                            ))}

                          </TableBody>
                        </Table>
                      </TableContainer>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

BultenDetay.propTypes = {
  className: PropTypes.string
};

export default BultenDetay;
